import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { DonleeFechtAPI } from '../../api/Donlee';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RenderIf } from '../utils/RenderIf';

import Accordion from 'react-bootstrap/Accordion';
 import './ModuleLocator.css';


function ModuleLocator({ locator, setLocator }) {
    const [showModal, setShowModal] = useState(false)
    let token = localStorage.getItem('x-access-machine-token');
    const [tempClient_Phone, setTempClient_Phone] = useState("");
    const [handler, setHandler] = useState(0)


    //Hook to load the initial info
    useEffect(() => {
        setHandler(0)
    }, [handler]);


    return (
        <>
            <div className="sp-loc">
                <div className="sp-loc__head">
                    <span className="sp-loc__title"><i className="uil uil-location-point"></i> Ingresa el Número</span>
                    {locator ? <span className="sp-loc__badge" translate="no">{locator}</span> : null}
                </div>
                <div className="sp-loc__body">
                    <div className="sp-loc__inputwrap">
                        <i className="uil uil-search sp-loc__inputic"></i>
                        <input
                            type="text"
                            className="sp-loc__input"
                            placeholder="Número de localizador"
                            value={locator}
                            onChange={(e) => (setLocator(e.target.value))}
                        />
                    </div>
                </div>
            </div>



        </>
    )
}

export default ModuleLocator